<template>
    <div>
        <el-row class="examHeader">
            <el-col :span='10'>
                <h1>您正在进行模拟考试</h1>
            </el-col>
            <el-col :span='4' :offset='10' class="totalQesNum">
                <span>共{{qesList.length}}题</span>
            </el-col>
        </el-row>
        <el-row>
            <el-col>

            </el-col>
        </el-row>
    </div>
</template>
<script>
// import { countdowm } from '../../../utils/date.js';
export default {
    props: {
        qesList: {
            type: Array
        },
        // downTime:{
        //     type:String
        // }
    },
    data () {
        return {
            // time : '',
            // timer : null
        }
    },
    mounted(){
        // this.time = this.downTime;
        // this.countdowm(this.time);
    },
    beforeDestroy(){
        // clearInterval(this.timer)
    },
    methods: {
        // countdowm (timestamp) {
        //     let self = this;
        //     this.timer = setInterval( () => {
        //         console.log(999)
        //         this.time = countdowm.init(timestamp,this._callback);
        //     }, 1000);
        // },
        // _callback () {
        //     clearInterval(this.timer);
        //     // if (this.callback && this.callback instanceof Function) {
        //         // console.log('结束1')
        //         // this.callback(...this);
        //     // }
        // }
    }
}
</script>
<style lang="stylus" scoped>
.examHeader
    padding-bottom 16px
    border-bottom 1px dashed #667DAB
    h1
        font-size 18px
        color #333
        background-image $menu_border
        background-repeat no-repeat
        background-position left 3px
        background-size 4px 18px
        padding-left 10px
        margin-left 20px
    .totalQesNum
        text-align right
</style>


// WEBPACK FOOTER //
// src/components/my/exam/examHeader.vue